import React, { useMemo, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsAccessibility from "highcharts/modules/accessibility";
import { useTheme } from "@mui/material/styles";
import { useGetAllInsuranceCompanyDhashboardQuery } from "../../../Api/attoDeskApi";
import { IInsuranceComapyPieChart } from "../../../Api/Interface/api.interface";
import { useStyles } from "../../../theme/appStyles";

HighchartsMore(Highcharts);
HighchartsExporting(Highcharts);
HighchartsAccessibility(Highcharts);

const PayrollDashboard = () => {
  const classes = useStyles();
  const theme = useTheme();
  const [showTable, setShowTable] = useState(false);

  const { data: payrollApiData, isLoading } =
    useGetAllInsuranceCompanyDhashboardQuery({ id: "" });

  const payrollData = useMemo(() => {
    return (payrollApiData?.data as IInsuranceComapyPieChart[]) || [];
  }, [payrollApiData?.data]);

  if (isLoading) return <div style={{ padding: "5px" }}>Loading...</div>;

  const companyCounts = payrollData.reduce((acc, item) => {
    const name = item.policyInsuranceCompanyName || "Unknown";
    acc[name] = (acc[name] || 0) + 1;
    return acc;
  }, {} as Record<string, number>);

  const pieData = Object.entries(companyCounts).map(([name, count]) => ({
    name,
    y: count,
  }));

  const salaryTrendOptions: Highcharts.Options = {
    chart: { type: "pie", backgroundColor: theme.palette.cardAdd.bgColor },
    title: {
      text: "Policies by Insurance Company",
      style: {
        fontSize: "0.9375rem",
        color: theme.palette.heading.headingColor,
      },
    },
    tooltip: {
      pointFormat: "<b>{point.y} Policies</b> ({point.percentage:.1f}%)",
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.percentage:.1f} %",
          style: {
            color: theme.palette.heading.headingColor,
            fontSize: "0.75rem",
          },
        },
      },
    },
    legend: {
      itemStyle: {
        fontSize: "0.75rem",
        color: theme.palette.heading.headingColor,
      },
    },
    series: [
      {
        type: "pie",
        name: "Policies",
        data: pieData,
      },
    ],
    credits: { enabled: false },
  };

  return (
    <div style={{ padding: "5px" }}>
      <HighchartsReact highcharts={Highcharts} options={salaryTrendOptions} />
    </div>
  );
};

export default PayrollDashboard;
